<template>
  <div class="c-table">

    <el-table
      :data="dataSource"
      type="selection"
      ref="ctable"
    >
    <el-table-column v-if="selection" type="selection" width="55"></el-table-column>

      <slot></slot>

    </el-table>

    <div class="downloadOptions">
      <slot name="download"></slot>
    </div>

    <el-pagination
      class="pages"
      @current-change="handlePageChange"
      :current-page.sync="pagination.current"
      :page-size="pagination.pageSize"
      layout="total, prev, pager, next,jumper"
      :total="pagination.total"
    >
    </el-pagination>

  </div>
</template>

<script>
export default {
  props: {
    queryParams: Array,
    columns: Array,
    dataSource: Array,
    pagination: {},
    selection:Boolean
  },
  data: function() {
    return {
      list: []
    };
  },
  methods: {
    handlePageChange(val) {
      this.$emit("handlePageChange", val);
    },
    getSelections(){
     const selection =  this.$refs.ctable.selection
     return selection
    },
    clearSelection(){
      this.$refs.ctable.clearSelection()
    }
  }
};
</script>


<style lang="scss">
.c-table {
  width: 100%;
  position: relative;
      min-width: 1024px;
}
.pages {
  text-align: right;
  margin-top: 22px;
}
.downloadOptions {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: 9px;
    font-size: 13px;
    a{
      text-decoration: underline;
      // color:$gray-color;
      color:$main-color;

      margin-left: 10px;
    }
}
.el-dialog__footer{
      padding: 10px 20px;
}
</style>

